import { cn } from "@/lib/utils";

// Overlays its parent's top edge — parent must be `relative`.
const LoadingBar = ({ className }) => (
  <div
    className={cn(
      "absolute left-0 right-0 top-0 z-10 h-0.5 w-full overflow-hidden bg-muted/40",
      className,
    )}
  >
    <div
      className="h-full w-1/3 bg-primary"
      style={{ animation: "app-loading-bar 1.2s ease-in-out infinite" }}
    />
  </div>
);

export default LoadingBar;
